import store from '@/store'

export default class UpdateTitleMiddleware {
    handle(to, from, next) {
        if (!to || !to.meta.title) {
            document.title = store.getters['company/program_name'] || 'Fidelidade'
            return true
        }

        document.title = store.getters[to.meta.title].title
        return true
    }
}